import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"max-width":"500px","margin":"100px auto"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout_header, null, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { style: {"padding":"20px","font-size":"20px","font-weight":"bold"} }, " Xuantu Admin ", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_a_layout_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            src: "http://statica.xuantu.pro/static/icons/appicon.jpg",
            style: {"display":"block","width":"200px","height":"200px","margin":"20px auto","background":"#EEE","border-radius":"8px"}
          }, null, -1)),
          _createVNode(_component_a_card, { title: "系统登录" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: _ctx.formState,
                onSubmit: _ctx.onSubmit,
                "label-col": _ctx.labelCol,
                "wrapper-col": _ctx.wrapperCol
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "手机号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        name: "phone",
                        required: "",
                        value: _ctx.formState.phone,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.phone) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "验证码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        name: "vcode",
                        required: "",
                        value: _ctx.formState.vcode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.vcode) = $event)),
                        style: {"width":"calc( 100% - 110px )"}
                      }, null, 8, ["value"]),
                      _createVNode(_component_a_button, {
                        block: "",
                        "html-type": "submit",
                        style: {"width":"100px","margin-left":"10px"},
                        disabled: _ctx.countDown > 0,
                        onClick: _ctx.getLoginPhoneCode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.countDown > 0 ? `${_ctx.countDown} 秒` : '获取验证码'), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 4 } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("登录", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onSubmit", "label-col", "wrapper-col"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_layout_footer, { style: {"position":"fixed","bottom":"0","width":"100%","text-align":"center"} }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createTextVNode("2024©copyright Xuantu", -1)
      ]))]),
      _: 1
    })
  ], 64))
}